<div class="active-jobs-container">
  <div class="grouped-jobs-summary" *ngIf="vm.groupedJobs.length > 0">
    <div class="summary-header">
      <h3 class="summary-title" (click)="vm.toggleGroupedJobs()">
        Active Jobs by Media
        <span class="summary-counts"
          >({{ vm.totalMedias }} media{{ vm.totalMedias > 1 ? "s" : "" }} with
          {{ vm.totalJobs }} job{{ vm.totalJobs > 1 ? "s" : "" }})</span
        >
      </h3>
      <span
        class="collapse-icon"
        [ngClass]="{ collapsed: vm.isGroupedJobsCollapsed }"
        (click)="vm.toggleGroupedJobs()"
      >
        ▼
      </span>
    </div>
    <div
      class="media-groups"
      [ngClass]="{ collapsed: vm.isGroupedJobsCollapsed }"
    >
      <div
        class="media-group"
        *ngFor="let group of vm.groupedJobs"
        [attr.data-base-name]="group.baseName"
        [ngClass]="{
          selected: vm.isNameFilterActiveForBaseName(group.baseName),
        }"
      >
        <div class="media-info">
          <span class="media-name">{{ group.baseName }}</span>
          <span class="job-count"
            >({{ group.jobCount }} job{{ group.jobCount > 1 ? "s" : "" }})</span
          >
        </div>
      </div>
    </div>
  </div>
  <div class="filters-bar flex row">
    <div class="filter-group">
      <span class="filter-label">Name</span>
      <input
        class="name-filter-input"
        type="search"
        placeholder="Search by name"
        [ngModel]="vm.nameFilter"
        (ngModelChange)="vm.setNameFilter($event)"
      />
    </div>
    <div class="filter-group">
      <span class="filter-label">Item Status</span>
      <icn-dropdown
        class="filter-dropdown"
        [position]="'bottom'"
        [placeholder]="'All'"
        [selectedValue]="vm.selectedItemStatusFilter"
        (selectedValueChange)="vm.setItemStatusFilter($event)"
      >
        <icn-dropdown-item
          *ngFor="let option of vm.statusFilterOptions"
          [title]="option.label === 'InEngineQueue' ? 'In Queue' : option.label"
          [value]="option.value"
        ></icn-dropdown-item>
      </icn-dropdown>
    </div>
  </div>
  <table class="jobs-table">
    <thead>
      <tr>
        <th>Name</th>
        <th>Destination</th>
        <th>Estimated End Time</th>
        <th>Item Status</th>
        <th>Priority</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let job of vm.activeJobs" [routerLink]="'../edit/' + job.id">
        <td>{{ job.name }}</td>
        <td>{{ job.destination }}</td>
        <td>{{ job.estimatedEndTime }}</td>
        <td class="status-cell">
          {{
            job.itemStatusDisplay == "InEngineQueue"
              ? "In Queue"
              : job.itemStatusDisplay
          }}
        </td>
        <td>
          <span [ngClass]="job.priority">{{ job.priority }}</span>
        </td>
        <td class="actions-cell">
          <a [routerLink]="'../new/replicateFromId/' + job.id">
            <span>Replicate</span></a
          >
        </td>
      </tr>
    </tbody>
  </table>
</div>
